// extracted by mini-css-extract-plugin
module.exports = {"tokenBar":"oaEm6","btn":"_15Rns","check":"_83zVA"};